(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-sidebar"] && !Shopify.designMode) return;
  try {
    // class SidebarCollapse extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.button = this.querySelector(".blog-posts__sidebar-collapse-button");
  //     this.content = this.querySelector(".blog-posts__sidebar-collapse-content");
  //   }

  //   connectedCallback() {
  //     this.button.addEventListener("click", () => {
  //       this.content.setAttribute("aria-expanded", this.content.getAttribute("aria-expanded") === "true" ? "false" : "true");
  //     });
  //   }
  // }

  // customElements.define("sidebar-collapse", SidebarCollapse);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_cart-countdown"] && !Shopify.designMode) return;
  try {
    class cartCountdownComponent extends HTMLElement {
    constructor() {
      super();
      this.minutes = parseInt(this.getAttribute('data-minutes')) || 4;
      this.timeDisplay = this.querySelector('.time');
      this.storageKey = 'cartCountdownTime';
      this.intervalId = null;
      
      this.init();
    }

    init() {
      const storedTime = this.getStoredTime();
      const totalSeconds = storedTime !== null ? storedTime : this.minutes * 60;
      
      this.startCountdown(totalSeconds);
    }

    getStoredTime() {
      if (Shopify.designMode) return null;
      
      const stored = sessionStorage.getItem(this.storageKey);
      return stored ? parseInt(stored) : null;
    }

    setStoredTime(seconds) {
      if (!Shopify.designMode) {
        sessionStorage.setItem(this.storageKey, seconds.toString());
      }
    }

    clearStoredTime() {
      if (!Shopify.designMode) {
        sessionStorage.removeItem(this.storageKey);
      }
    }

    formatTime(totalSeconds) {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    updateDisplay(totalSeconds) {
      if (this.timeDisplay) {
        this.timeDisplay.textContent = this.formatTime(totalSeconds);
      }
    }

    async clearCart() {
      try {
        const response = await fetch(`${Shopify.routes.root}cart/clear.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        if (response.ok) {
          window.location.href = `${Shopify.routes.root}cart`;
        } else {
          throw new Error('Failed to clear cart');
        }
      } catch (error) {
        console.error('Error clearing cart:', error);
        window.location.href = `${Shopify.routes.root}cart`;
      }
    }

    startCountdown(totalSeconds) {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.updateDisplay(totalSeconds);

      this.intervalId = setInterval(() => {
        totalSeconds--;
        
        this.updateDisplay(totalSeconds);
        this.setStoredTime(totalSeconds);

        if (totalSeconds <= 0) {
          this.onCountdownComplete();
        }
      }, 1000);
    }

    onCountdownComplete() {
      clearInterval(this.intervalId);
      this.clearStoredTime();
      this.updateDisplay(0);
      
      this.clearCart();
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }

  customElements.define('cart-countdown-component', cartCountdownComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-blog-articles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    handleResize();

    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slideshow').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tab-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length === 0 || tabContents.length === 0) return;

    tabContents[0].classList.add('is-active');

    tabTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.preventDefault();
        tabContents.forEach(content => {
          content.classList.remove('is-active');
        });
        const tabContent = this.nextElementSibling;
        if (tabContent) {
          tabContent.classList.add('is-active');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyATC extends HTMLElement {
    constructor() {
      super();

    this.form = null;
    this.mainProductInfo = null;
    this.mainVariantSelects = null;
    this.stickyVariantSelects = null;
    this.isSyncing = false;
    this.cartErrorUnsubscriber = null;
    
    this.init();
  }
  
  init() {
    this.findMainForm();
    
    if (this.form) {
      const observer = new IntersectionObserver(this.onScroll.bind(this));
      observer.observe(this.form);
    } else {
      console.warn('Sticky ATC: Could not find product form');
    }
    
    setTimeout(() => {
      this.initializeVariantSync();
    }, 100);
    
    this.setupErrorSync();
  }
  
  setupErrorSync() {
    this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      const mainErrorWrapper = this.mainProductInfo?.querySelector('.product-form__error-message-wrapper');
      const stickyErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
      
      if (!mainErrorWrapper || !stickyErrorWrapper) return;
      
      const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
      
      const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
      if (stickyErrorMessage && errorMessage) {
        stickyErrorWrapper.toggleAttribute('hidden', false);
        stickyErrorMessage.textContent = errorMessage;
      } else {
        stickyErrorWrapper.toggleAttribute('hidden', true);
      }
    });
    
    if (this.mainProductInfo) {
      const errorWrapper = this.mainProductInfo.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) {
        const observer = new MutationObserver(() => {
          const stickyErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          if (!stickyErrorWrapper) return;
          
          const isVisible = !errorWrapper.hasAttribute('hidden');
          const errorMessage = errorWrapper.querySelector('.product-form__error-message')?.textContent;
          
          stickyErrorWrapper.toggleAttribute('hidden', !isVisible);
          if (isVisible && errorMessage) {
            const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
            if (stickyErrorMessage) {
              stickyErrorMessage.textContent = errorMessage;
            }
          }
        });
        
        observer.observe(errorWrapper, {
          attributes: true,
          attributeFilter: ['hidden'],
          childList: true,
          subtree: true
        });
      }
    }
  }
  
  disconnectedCallback() {
    if (this.cartErrorUnsubscriber) {
      this.cartErrorUnsubscriber();
    }
  }
  
  findMainForm() {
      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        this.form = productInfo.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      }
      
    if (!this.form && this.getAttribute('form')) {
      this.form = document.getElementById(this.getAttribute('form'));
      }

      if (!this.form) {
        this.form = document.querySelector('form[data-type="add-to-cart-form"]');
    }
  }
  
  initializeVariantSync() {
    const sectionId = this.getAttribute('data-sticky-section-id');
    this.mainProductInfo = document.querySelector(
      sectionId
        ? `product-info[data-section="${sectionId}"], product-info[data-original-section="${sectionId}"]`
        : 'product-info'
    ) || document.querySelector('product-info');

    this.stickyVariantSelects = this.querySelector('variant-selects');
    
    if (this.mainProductInfo) {
      this.mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
    }
    
    if (this.stickyVariantSelects && this.mainVariantSelects) {
      this.setupVariantSync();
      this.setupToggleButton();
      this.syncInitialState();
      this.updateStickyAvailabilityFromMain();
      this.observeMainAvailabilityChanges();
    }
  }
  
  setupVariantSync() {
    this.mainVariantSelects.addEventListener('change', (event) => {
      if (this.isSyncing) return;
      this.syncMainToSticky(event);
      this.updateStickyAvailabilityFromMain();
    });
    
    this.stickyVariantSelects.addEventListener('change', (event) => {
      if (this.isSyncing) return;

      const t = this.getInputFromEventTarget(event.target);
      if (t && t.type === 'radio') {
        const wrapper = t.closest('.product-form__input') || this.stickyVariantSelects;
        wrapper
          .querySelectorAll('input[type="radio"]')
          .forEach((el) => {
            el.classList.remove('checked');
            if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
              el.nextElementSibling.classList.remove('checked');
            }
          });
        t.classList.add('checked');
        if (t.nextElementSibling && t.nextElementSibling.tagName === 'LABEL') {
          t.nextElementSibling.classList.add('checked');
        }
      }

      this.syncStickyToMain(event);
    });

    this.stickyVariantSelects.addEventListener('click', (event) => {
      if (this.isSyncing) return;
      const input = this.getInputFromEventTarget(event.target);
      if (!input) return;

      if (input.type === 'radio') {
        const wrapper = input.closest('.product-form__input') || this.stickyVariantSelects;
        wrapper
          .querySelectorAll('input[type="radio"]')
          .forEach((el) => {
            el.classList.remove('checked');
            if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
              el.nextElementSibling.classList.remove('checked');
            }
          });
        input.classList.add('checked');
        if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
          input.nextElementSibling.classList.add('checked');
        }
      }

      requestAnimationFrame(() => {
        this.syncStickyToMain({ target: input });
      });
    });
  }
  
  setupToggleButton() {
    const buttonToggleVariants = this.querySelector('.button-toggle-variants');
    const overlay = this.querySelector('overlay-component');
    if (!buttonToggleVariants) return;

    const closePanel = () => {
      this.classList.remove('is-active');
      document.removeEventListener('click', handleClickOutside, true);
      if (overlay) overlay.removeEventListener('click', closePanel);
    };

    const handleClickOutside = (evt) => {
      if (!this.contains(evt.target) && evt.target !== overlay) {
        closePanel();
      }
    };

    buttonToggleVariants.addEventListener('click', (e) => {
      const isOpen = this.classList.contains('is-active');

      if (isOpen) {
        closePanel();
      } else {
        this.classList.add('is-active');
        document.addEventListener('click', handleClickOutside, true);
        if (overlay) overlay.addEventListener('click', closePanel);
      }
    });
  }

  syncInitialState() {
    this.ensureMainVariantInitialization();
    
    const mainSelectedOptions = this.mainVariantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    
    mainSelectedOptions.forEach((mainOption) => {
      const optionValueId = mainOption.dataset.optionValueId;
      if (!optionValueId) return;
      
      const stickyOption = this.stickyVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (!stickyOption) return;
      
      if (stickyOption.tagName === 'INPUT' && stickyOption.type === 'radio') {
        if (!stickyOption.checked) {
          stickyOption.checked = true;
          stickyOption.classList.add('checked');
        }
      } else if (stickyOption.tagName === 'OPTION') {
        const select = stickyOption.closest('select');
        if (select && select.value !== stickyOption.value) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          stickyOption.setAttribute('selected', 'selected');
          select.value = stickyOption.value;
        }
      }
    });
  }
  
  ensureMainVariantInitialization() {
    const mainSelectedOptions = this.mainVariantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    
    if (mainSelectedOptions.length === 0) {
      const variantGroups = this.mainVariantSelects.querySelectorAll('fieldset, .product-form__input');
      
      variantGroups.forEach(group => {
        const firstAvailableInput = group.querySelector('input[type="radio"]:not(.disabled)');
        const firstAvailableOption = group.querySelector('option:not([disabled])');
        
        if (firstAvailableInput && !firstAvailableInput.checked) {
          firstAvailableInput.checked = true;
          firstAvailableInput.classList.add('checked');
          
          const selectedValueSpan = group.querySelector('[data-selected-value]');
          if (selectedValueSpan) {
            selectedValueSpan.innerHTML = firstAvailableInput.value;
          }
          
          firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (firstAvailableOption && !firstAvailableOption.selected) {
          const select = firstAvailableOption.closest('select');
          if (select) {
            Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
            firstAvailableOption.setAttribute('selected', 'selected');
            select.value = firstAvailableOption.value;
            
            const selectedValueSpan = group.querySelector('[data-selected-value]');
            if (selectedValueSpan) {
              selectedValueSpan.innerHTML = firstAvailableOption.value;
            }
            
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    } else {
      console.log('Main variant selects already have selected options:', mainSelectedOptions.length);
    }
  }
  
  syncMainToSticky(event) {
    this.isSyncing = true;
    
    try {
      this.stickyVariantSelects = this.querySelector('variant-selects') || this.stickyVariantSelects;

      const target = event.target;
      const optionValueId = this.getOptionValueId(target);
      if (!optionValueId || !this.stickyVariantSelects) return;
      
      const stickyOption = this.stickyVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (!stickyOption) return;
      
      if (stickyOption.tagName === 'INPUT' && stickyOption.type === 'radio') {
        if (!stickyOption.checked) {
          const wrapper = stickyOption.closest('.product-form__input') || this.stickyVariantSelects;
          wrapper
            .querySelectorAll('input[type="radio"]')
            .forEach((el) => {
              el.checked = false;
              el.classList.remove('checked');
              if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
                el.nextElementSibling.classList.remove('checked');
              }
            });
          stickyOption.checked = true;
          stickyOption.classList.add('checked');
          if (stickyOption.nextElementSibling && stickyOption.nextElementSibling.tagName === 'LABEL') {
            stickyOption.nextElementSibling.classList.add('checked');
          }
        }
      } else if (stickyOption.tagName === 'OPTION') {
        const select = stickyOption.closest('select');
        if (select && select.value !== stickyOption.value) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          stickyOption.setAttribute('selected', 'selected');
          select.value = stickyOption.value;
        }
      }

      requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
    } finally {
      this.isSyncing = false;
    }
  }
  
  syncStickyToMain(event) {
    this.isSyncing = true;
    
    try {
      if (this.mainProductInfo) {
        this.mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
      }

      const target = this.getInputFromEventTarget(event.target) || event.target;
      const optionValueId = this.getOptionValueId(target);
      
      if (!this.mainVariantSelects) return;
      
      const mainOption = this.findMainOptionForStickyTarget(optionValueId, target);
      if (!mainOption) {
        console.warn('Sticky->Main: No main option found for', optionValueId, target?.name, target?.value);
        return;
      }
      
      if (mainOption.tagName === 'INPUT' && mainOption.type === 'radio') {
        const group = mainOption.name;
        Array.from(document.getElementsByName(group)).forEach((el) => {
          if (el instanceof HTMLInputElement && el.type === 'radio') {
            el.checked = false;
            el.classList.remove('checked');
          }
        });
        mainOption.checked = true;
        mainOption.classList.add('checked');
        requestAnimationFrame(() => {
          mainOption.dispatchEvent(new Event('input', { bubbles: true }));
          mainOption.dispatchEvent(new Event('change', { bubbles: true }));
          requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
        });
      } else if (mainOption.tagName === 'OPTION') {
        const select = mainOption.closest('select');
        if (select) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          mainOption.setAttribute('selected', 'selected');
          select.value = mainOption.value;
          requestAnimationFrame(() => {
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
          });
        }
      }
    } finally {
      this.isSyncing = false;
    }
  }
  
  getOptionValueId(element) {
    const el = this.getInputFromEventTarget(element) || element;
    if (el && el.tagName === 'SELECT') {
      return el.selectedOptions[0]?.dataset.optionValueId;
    } else if (el && el.type === 'radio' && el.checked) {
      return el.dataset.optionValueId;
    }
    return null;
  }

  findMainOptionForStickyTarget(optionValueId, stickyInput) {
    if (optionValueId) {
      const byId = this.mainVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (byId) return byId;
    }

    if (stickyInput && stickyInput.name && stickyInput.value) {
      let candidates = Array.from(document.getElementsByName(stickyInput.name));
      if (!candidates.length) candidates = Array.from(document.getElementsByName(stickyInput.name.trim()));

      const radioMatch = candidates.find(
        (el) => el instanceof HTMLInputElement && el.type === 'radio' && el.value === stickyInput.value
      );
      if (radioMatch) return radioMatch;

      if (stickyInput.tagName === 'OPTION') {
        const selectName = stickyInput.closest('select')?.name;
        if (selectName) {
          let mainSelects = Array.from(document.getElementsByName(selectName));
          if (!mainSelects.length) mainSelects = Array.from(document.getElementsByName(selectName.trim()));
          const mainSelect = mainSelects.find((el) => el instanceof HTMLSelectElement);
          if (mainSelect) {
            const option = Array.from(mainSelect.options).find((opt) => opt.value === stickyInput.value);
            if (option) return option;
          }
        }
      }
    }

    return null;
  }

  getInputFromEventTarget(target) {
    if (target && target.tagName === 'LABEL') {
      const forId = target.getAttribute('for');
      if (forId) return document.getElementById(forId);
      if (target.previousElementSibling && target.previousElementSibling.tagName === 'INPUT') {
        return target.previousElementSibling;
      }
    }
    
    const wrapper = target.closest && target.closest('.product-form__input');
    if (wrapper) {
      const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio;
      const selectEl = wrapper.querySelector('select');
      if (selectEl) return selectEl;
    }
    
    if (target && (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'OPTION')) return target;
    return null;
  }

  updateStickyAvailabilityFromMain() {
    if (!this.mainVariantSelects || !this.stickyVariantSelects) return;

    const mainOptions = this.mainVariantSelects.querySelectorAll(
      'input[type="radio"][data-option-value-id], select option[data-option-value-id]'
    );

    mainOptions.forEach((mainEl) => {
      const id = mainEl.dataset.optionValueId;
      if (!id) return;
      const stickyEl = this.stickyVariantSelects.querySelector(`[data-option-value-id="${id}"]`);
      if (!stickyEl) return;

      let mainUnavailable = false;
      if (mainEl.tagName === 'INPUT') {
        const input = mainEl;
        const label = input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null;
        mainUnavailable = !!(
          input.disabled ||
          input.getAttribute('aria-disabled') === 'true' ||
          input.classList.contains('disabled') ||
          input.classList.contains('visually-disabled') ||
          (label && (label.classList.contains('disabled') || label.classList.contains('visually-disabled') || label.classList.contains('unavailable') || label.classList.contains('sold-out')))
        );
      } else {
        mainUnavailable = mainEl.disabled || mainEl.getAttribute('aria-disabled') === 'true';
      }

      if (stickyEl.tagName === 'INPUT') {
        stickyEl.disabled = mainUnavailable;
        if (mainUnavailable) {
          stickyEl.setAttribute('aria-disabled', 'true');
          stickyEl.classList.add('disabled', 'visually-disabled');
          const label = stickyEl.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.add('disabled', 'visually-disabled');
          }
        } else {
          stickyEl.removeAttribute('aria-disabled');
          stickyEl.classList.remove('disabled', 'visually-disabled');
          const label = stickyEl.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.remove('disabled', 'visually-disabled');
          }
        }
      } else if (stickyEl.tagName === 'OPTION') {
        if (mainUnavailable) {
          stickyEl.setAttribute('disabled', '');
          stickyEl.setAttribute('aria-disabled', 'true');
        } else {
          stickyEl.removeAttribute('disabled');
          stickyEl.removeAttribute('aria-disabled');
        }
      }
    });
  }

  observeMainAvailabilityChanges() {
    if (!this.mainVariantSelects) return;
    const debouncedUpdate = (() => {
      let rafId = null;
      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
      };
    })();

    const observer = new MutationObserver(debouncedUpdate);
    observer.observe(this.mainVariantSelects, {
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
      subtree: true,
      childList: true
    });
    this._availabilityObserver = observer;
    }

    onScroll(entries) {
      entries.forEach((entry) => {
        if (entry.target === this.form) this.passedForm = entry.boundingClientRect.bottom < 0;
      });

      const shouldShow = this.passedForm && !this.reachedFooter;
      document.body.classList.toggle('sticky-cart-visible', shouldShow);
      this.classList.toggle('is-visible', shouldShow);
    
      if (shouldShow) {
        document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-atc-height', `0px`);
      }

      if (!shouldShow) this.classList.remove('sticky-open');
    }
  }

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyATC);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    constructor() {
      super();
      this._handleOutsideClick = this._handleOutsideClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[id^="EmailSignup-"]');
      this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
      this.submitButton = this.form?.querySelector("button[id^='EmailSignup-submit-']");
      this.subscriptionForm = this.querySelector('.subscription-form');
      this.emailForm = this.querySelector('.email-signup__form');
      this.promoBtn = this.querySelector('.promo-btn');
      // this.backBtn = this.emailForm.querySelector('.back-btn');

      this.initAgreeCondition();
      this.initPromoToggle();

      if (window.location.search.includes('contact_posted=true')) {
        this.showEmailForm(true);
      }
    }

    initAgreeCondition() {
      if (!this.checkbox || !this.submitButton) return;

      this.submitButton.disabled = true;

      this.checkbox.addEventListener('change', () => {
        this.submitButton.disabled = !this.checkbox.checked;
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          alert('Please agree to the terms and conditions before submitting.');
        }
      });
    }

    initPromoToggle() {
      if (!this.subscriptionForm || !this.emailForm || !this.promoBtn) return;

      this.emailForm.style.display = 'none';

      this.promoBtn.addEventListener('click', () => this.showEmailForm());
      // this.backBtn?.addEventListener('click', () => this.showSubscriptionForm());
    }

    async showEmailForm(skipHideAnim = false) {
      if (!skipHideAnim) await this._animateHide(this.subscriptionForm);
      this.subscriptionForm.style.display = 'none';
      this.emailForm.style.display = '';
      await this._animateShow(this.emailForm);

      document.addEventListener('click', this._handleOutsideClick);
    }

    async showSubscriptionForm() {
      await this._animateHide(this.emailForm);
      this.emailForm.style.display = 'none';
      this.subscriptionForm.style.display = '';
      await this._animateShow(this.subscriptionForm);

      document.removeEventListener('click', this._handleOutsideClick);
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this.showSubscriptionForm();
      }
    }

    async _animateShow(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [
          element,
          { height: ['0px', `${element.scrollHeight}px`] },
          { duration: 0.45, easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
        [
          element,
          { opacity: [0, 1], transform: ['translateX(-1rem)', 'translateX(0)'] },
          { duration: 0.25, at: '-0.1' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }

    async _animateHide(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [element, { opacity: 0, transform: ['translateX(0)', 'translateX(1rem)'] }, { duration: 0.15 }],
        [
          element,
          { height: [`${element.clientHeight}px`, '0px'] },
          { duration: 0.35, at: '<', easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }
  }
  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promotion-coupon-code"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".coupon-code-block .coupon-code-icon").forEach(function (btn) {
        btn.addEventListener("click", function () {
        const parent = btn.closest(".coupon-code-block");
        const text = parent.getAttribute("data-text");

        parent.classList.add("copied");
        setTimeout(() => {
            parent.classList.remove("copied");
        }, 1500);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
